/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'panamera-react-ui';
import InspectionTabContent from './InspectionTabContent';
import css from './InspectionReport.APP_TARGET.scss';
import { ADPV_EVENTS, FLOW_STEP } from 'Constants/tracking';

const { TabsContainer, TabContent, TabTitle } = Tabs;

class InspectionReport extends React.PureComponent {
    static propTypes = {
        damageReport: PropTypes.object.isRequired,
        onTrack: PropTypes.func.isRequired,
        onHandleImgTap: PropTypes.func.isRequired,
        trackImagePagination: PropTypes.func,
        filterInspection: PropTypes.bool
    }

    constructor(props) {
        super(props);
        this.selectedTab = this.props.damageReport.values[0].id;
    }

    handleTrackTagTap = trackObj => {
        this.props.onTrack(ADPV_EVENTS.INSPECTION_SUB_AREA, {
            ...trackObj,
            select_from: this.selectedTab,
            flow_step: FLOW_STEP.ADP
        });
    }

    handleTrackTabTap = id => {
        this.selectedTab = this.props.damageReport.values[id].id;

        this.props.onTrack(ADPV_EVENTS.INSPECTION_AREA, {
            chosen_option: this.selectedTab,
            flow_step: FLOW_STEP.ADP
        });
    }

    getTabs() {
        const { filterInspection, damageReport } = this.props;
        const { values = [] } = damageReport;

        const tabs = [];

        values.forEach((val, idx) => {
            !filterInspection
                && tabs.push(
                    <TabTitle
                        key={ `tabtitle${val.id}` }
                        listItemClassName={ css.tab }
                        className={ css.tabTitle }
                        selectedClass={ css.selected }
                        id={ idx }
                    >
                        <span>{val.name}</span>
                    </TabTitle>
                );

            tabs.push(
                <TabContent
                    key={ `tabcontent${val.id}` }
                    className={ css.tabContent }
                    listClassName={ css.list }
                >
                    <InspectionTabContent
                        tags={ val.tags }
                        tabTitle={ val.name }
                        onTrackTagTap={ this.handleTrackTagTap }
                        onHandleImgTap={ this.props.onHandleImgTap }
                        selectedTab={ val.id }
                        trackImagePagination={ this.props.trackImagePagination }
                    />
                </TabContent>
            );
        });

        return tabs;
    }

    render() {
        return (
            <React.Fragment>
                <div className={ css.subHeading }>
                    {this.props.damageReport.name}
                </div>
                <TabsContainer
                    listClassName={ css.tabContainer }
                    onClick={ this.handleTrackTabTap }
                    className={ css.tabsContainer }
                >
                    {this.getTabs()}
                </TabsContainer>
            </React.Fragment>
        );
    }
}

export default InspectionReport;

